/**
 * Combo "Super Oferta" - gift with purchase, cart-side sync.
 *
 * This handles the UX layer only: auto-adding the gift variant when the
 * main product form is submitted, syncing the gift quantity whenever the
 * main product's cart line quantity changes, and removing the gift when
 * the main product is removed. Every gift line item gets marked with
 * line item properties (_combo_regalo: "true", _combo_de: <main product
 * id>) so the Shopify Function (deployed separately, product discount
 * type) can find it and apply the real $0 discount at checkout - THIS
 * script never fakes the price, it only manages what's in the cart.
 */
(function () {
  var combos = []; // { mainProductId, giftVariantId, giftsPerUnit }

  function registerCombo(config) {
    combos.push(config);
    bindMainProductForm(config);
  }

  function bindMainProductForm(config) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (form.dataset.rtxComboBound) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      form.dataset.rtxComboBound = '1';
      form.addEventListener('submit', function () {
        // Defer slightly so the main add-to-cart request goes first.
        setTimeout(function () {
          var qtyInput = form.querySelector('input[name="quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          addOrSyncGift(config, qty);
        }, 400);
      });
    });
  }

  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addOrSyncGift(config, mainQty) {
    var giftQtyNeeded = mainQty * config.giftsPerUnit;
    getCart().then(function (cart) {
      var existingGiftLine = cart.items.find(function (item) {
        return String(item.variant_id) === String(config.giftVariantId) &&
          item.properties && item.properties._combo_regalo === 'true' &&
          item.properties._combo_de === String(config.mainProductId);
      });
      if (existingGiftLine) {
        // Sync quantity to match total main product units in cart.
        var mainTotalQty = cart.items.reduce(function (sum, item) {
          if (String(item.product_id) === String(config.mainProductId)) {
            return sum + item.quantity;
          }
          return sum;
        }, 0);
        var targetQty = mainTotalQty * config.giftsPerUnit;
        if (existingGiftLine.quantity !== targetQty) {
          cartFetch('/cart/change.js', { line: cart.items.indexOf(existingGiftLine) + 1, quantity: targetQty })
            .then(refreshCartUI);
        }
      } else {
        cartFetch('/cart/add.js', {
          items: [{
            id: config.giftVariantId,
            quantity: giftQtyNeeded,
            properties: {
              '_combo_regalo': 'true',
              '_combo_de': String(config.mainProductId),
              'Regalo': '🎁 Incluido gratis con tu compra'
            }
          }]
        }).then(refreshCartUI);
      }
    });
  }

  function refreshCartUI() {
    // Update cart count bubble + trigger Dawn's cart notification/drawer refresh.
    getCart().then(function (cart) {
      var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
      if (bubble) bubble.textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  // Watch for main product line removal/quantity changes made directly in
  // the cart page or cart drawer (not just the product page "add" form),
  // so removing the main product also removes its gift.
  function watchCartPageChanges() {
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.matches('input[name="updates[]"], input.quantity__input')) return;
      setTimeout(syncAllCombosFromCart, 500);
    });
    document.addEventListener('click', function (e) {
      var removeLink = e.target.closest('cart-remove-button, a[href*="/cart/change"][data-index]');
      if (removeLink) setTimeout(syncAllCombosFromCart, 500);
    });
  }

  function syncAllCombosFromCart() {
    getCart().then(function (cart) {
      combos.forEach(function (config) {
        var mainTotalQty = cart.items.reduce(function (sum, item) {
          if (String(item.product_id) === String(config.mainProductId)) {
            return sum + item.quantity;
          }
          return sum;
        }, 0);
        var giftLine = cart.items.find(function (item) {
          return String(item.variant_id) === String(config.giftVariantId) &&
            item.properties && item.properties._combo_regalo === 'true' &&
            item.properties._combo_de === String(config.mainProductId);
        });
        var targetQty = mainTotalQty * config.giftsPerUnit;
        if (giftLine && targetQty === 0) {
          cartFetch('/cart/change.js', { line: cart.items.indexOf(giftLine) + 1, quantity: 0 }).then(refreshCartUI);
        } else if (giftLine && giftLine.quantity !== targetQty) {
          cartFetch('/cart/change.js', { line: cart.items.indexOf(giftLine) + 1, quantity: targetQty }).then(refreshCartUI);
        } else if (!giftLine && targetQty > 0) {
          cartFetch('/cart/add.js', {
            items: [{
              id: config.giftVariantId,
              quantity: targetQty,
              properties: {
                '_combo_regalo': 'true',
                '_combo_de': String(config.mainProductId),
                'Regalo': '🎁 Incluido gratis con tu compra'
              }
            }]
          }).then(refreshCartUI);
        }
      });
    });
  }

  window.RtxComboSync = { registerCombo: registerCombo };
  document.addEventListener('DOMContentLoaded', watchCartPageChanges);
})();
